import React, { useEffect, useState } from "react"
import { ISwift } from "../../../../types/dict/ISwift"
import * as TrinityAPI from "../../../../requests/TrinityAPI"
import { IErrorModel } from "../../../../types/error/IErrorModel"

export const SwiftPicker: React.FC<{
  label?: string
  name: string
  value: string | undefined
  errorModel: IErrorModel | undefined
  _callback: (swift: ISwift | undefined) => void
}> = ({ label, name, value, errorModel, _callback }) => {
  const [swift, setSwift] = useState<ISwift>()
  const [swiftValue, setSwiftValue] = useState<string | undefined>(value)

  useEffect(() => {
    setSwiftValue(value)
  }, [value])

  useEffect(() => {
    _callback(swift)
  }, [swift])

  const changeSwift = (swift: string) => {
    setSwiftValue(swift)
    if (swift.length < 7 || swift.length > 12) {
      return
    }
    TrinityAPI.suggestSwift(swift, response => {
      if (response.status === 200) {
        if (!response.data) {
          const customSwift: ISwift = {
            bank_name: "",
            city: "",
            country: "",
            country_code: "",
            swift_code: swift
          }
          setSwift(customSwift)
        } else {
          setSwift(response.data)
        }
      }
    })
  }

  const getFieldError = (fieldName: string) => {
    if (errorModel && errorModel.fieldErrors.filter(fe => fe.field === fieldName).length > 0) {
      return errorModel.fieldErrors.filter(fe => fe.field === fieldName)[0].defaultMessage
    }
  }

  return (
    <fieldset>
      {label && <legend>{label}</legend>}
      <input
        type="text"
        className="input-form"
        placeholder="SSVBCNSH"
        onChange={e => changeSwift(e.target.value)}
        value={swiftValue}
      />
      {getFieldError(name) ? <p className="error-form">{getFieldError(name)}</p> : <></>}
    </fieldset>
  )
}
